<div class="card" (click)="onCardClick()">
    <div *ngFor="let col of columns">
        <ng-container *ngIf="currentBusiness[col.field] !== undefined">
            <div class="title-value" *ngIf="col.headerTranslate">
                {{ col.headerTranslate | translate }}
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.icon">
                <img [src]="currentBusiness[col.field]" alt="icon" class="coupon-icon" />
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.fullDate">
                {{ currentBusiness[col.field] | date: 'dd/MM/yyyy' }}
            </div>
            <div class="field-value" *ngIf="col.type === fieldTypes.bool">
                <div *ngIf="!currentBusiness[col.field]">
                    <i class="pi pi-times-circle" style="color: red;"></i>
                </div>
                <div *ngIf="currentBusiness[col.field]">
                    <i class="pi pi-check-circle" style="color: green;"></i>
                </div>
            </div>
            <div class="field-value" *ngIf="!col.type">
                {{ currentBusiness[col.field] }}
            </div>
        </ng-container>
    </div>
</div>